<div class="page">
  <div class="admin">
    <app-e-logo />
    <div class="error">
      <img src="assets/images/not-found-error.png" />
      <p class="merck-font-title">{{ textConstants.ACCESS_DENIED }}</p>
      <p class="error-message">{{ textConstants.ACCESS_DENIED_SUBTITLE }}</p>
      <app-e-button [textContent]="textConstants.BACK" routerLink="/" />
    </div>
  </div>
</div>

